import React, { useEffect, useState } from 'react';

import Loader from '../lib/components/Loader';

import underwhelmingGentsUtil from '../lib/underwhelmingGentsUtil';

import api from '../utils/api';

import constants from '../lib/constants';

const getOrdinal = (number) => {
    if (number > 3 && number < 21) return 'th';
    switch (number % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
    }
}

const TeamSelectorDropdown = ({ teams, handleTeamUpdate, initialTeamId }) => {
    return (
        <select className="form-select" value={initialTeamId} onChange={(e) => handleTeamUpdate({ teamId: e.target.value })}>
            {teams.map((team, index) => (
                <option key={index} value={index}>{team}</option>
            ))}
        </select>
    )
}

const Trade = ({ outgoingPicks, playerData, userData }) => {
    const userPermissions = userData.permissions;
    const isAdmin = userPermissions === 'admin';
    const teams = constants.managerList;
    // const teams = constants.managerList.reduce((acc, cur) => {
    //     if (cur !== userPermissions) {
    //         acc.push(cur);
    //     }
    //     return acc;
    // }, []);

    const userIndex = teams.indexOf(userPermissions) === -1 ? 0 : teams.indexOf(userPermissions);

    const [selectedTeam1Id, updateSelectedTeam1Id] = useState(userIndex);
    const [selectedTeam2Id, updateSelectedTeam2Id] = useState(1);

    const [loading, updateLoading] = useState(false);
    
    const [assetsToTrade, updateAssetsToTrade] = useState({ [selectedTeam1Id]: [], [selectedTeam2Id]: []});

    const [draftOrdersByYear, updateDraftOrdersByYear] = useState({});
    const [draftOrderLoading, updateDraftOrderLoading] = useState(true);

    useEffect(() => {
        updateDraftOrderLoading(true);
        api.get('/api/v1/draft/orders').then(({ data }) => {
            updateDraftOrdersByYear(data);
            updateDraftOrderLoading(false);
        }).catch(err => {
            console.error('Error retrieving draft orders', err);
            updateDraftOrdersByYear({});
            updateDraftOrderLoading(false);
        });
    }, []);

    if (draftOrderLoading) {
        return <Loader />;
    }

    const PLAYER_ASSET_TYPE = 'player';
    const PICK_ASSET_TYPE = 'pick';
    const FAAB_ASSET_TYPE = 'FAAB';

    const handleTeam1IdUpdate = ({ teamId: selectedTeamId }) => {
        const temp = assetsToTrade;
        delete temp[selectedTeam1Id];
        temp[selectedTeamId] = [];
        updateAssetsToTrade(temp);

        if( selectedTeamId !== selectedTeam2Id) {
            updateSelectedTeam1Id(selectedTeamId);
        }
    };
    
    const handleTeam2IdUpdate = ({ teamId: selectedTeamId }) => {
        const temp = assetsToTrade;
        delete temp[selectedTeam2Id];
        temp[selectedTeamId] = [];
        updateAssetsToTrade(temp);

        if( selectedTeamId !== selectedTeam1Id) {
            updateSelectedTeam2Id(selectedTeamId);
        }
    };
    
    const proposeTrade = () => {
        const tradeData = { 
            [teams[selectedTeam1Id]]: assetsToTrade[selectedTeam1Id],
            [teams[selectedTeam2Id]]: assetsToTrade[selectedTeam2Id]
        };
        updateLoading(true);
        api.post('/api/v2/transactions/trade', { tradeAway: tradeData, proposedBy: teams[selectedTeam1Id] }).then((res) => {
            alert('Trade proposed!');
            updateLoading(false);
        }).catch(err => {
            console.error(err);
            alert('Something went wrong, trade not proposed');
            updateLoading(false);
        });
    };

    const checkboxChanged = (e) => { 
        const id = e.currentTarget.id;
        const checked = e.currentTarget.checked;
        const teamMakingTrade = teams.indexOf(id.split('-')[0]);

        const assetType = id.split('-')[1];
        const temp = assetsToTrade[teamMakingTrade];
        console.log( {temp, assetsToTrade});

        if (assetType === PLAYER_ASSET_TYPE) {
            const playerId = id.split('-')[2];
            if (checked) {
                temp.push(playerId);
                updateAssetsToTrade({ 
                    ...assetsToTrade,
                    [teamMakingTrade]: temp
                });
            } else {
                updateAssetsToTrade({
                    ...assetsToTrade,
                    [teamMakingTrade]: temp.filter(value => value !== playerId)
                });
            }

        } else if (assetType === PICK_ASSET_TYPE) {
            const pickId = id.split('-')[2];

            if (checked) {
                temp.push(pickId);
                updateAssetsToTrade({ 
                    ...assetsToTrade,
                    [teamMakingTrade]: temp
                });
            } else {
                updateAssetsToTrade({
                    ...assetsToTrade,
                    [teamMakingTrade]: temp.filter(value => value !== pickId)
                });
            }

        } else if (assetType === FAAB_ASSET_TYPE) {
            const [managerName, _faab, type, year] = id.split('-');
            const faabChecked = document.getElementById(`${managerName}-${FAAB_ASSET_TYPE}-check-${year}`).checked;
            const faabValue = document.getElementById(`${managerName}-${FAAB_ASSET_TYPE}-value-${year}`).value || 0;

            const faabKey = `${FAAB_ASSET_TYPE}_${year}_${faabValue}`;

            if (type === 'check') {
                if (faabChecked) {
                    temp.push(faabKey);
                    updateAssetsToTrade({ 
                        ...assetsToTrade,
                        [teamMakingTrade]: temp
                    });
                } else {
                    updateAssetsToTrade({
                        ...assetsToTrade,
                        [teamMakingTrade]: temp.filter(value => value !== faabKey)
                    });
                }
            } else if (faabChecked) {
                // we are updating the value now
                // remove the old key from temp
                const tempWithoutOldKey = temp.filter(value => !value.includes(`${FAAB_ASSET_TYPE}_${year}`));
                // add the new key to temp
                tempWithoutOldKey.push(faabKey);
                updateAssetsToTrade({
                    ...assetsToTrade,
                    [teamMakingTrade]: tempWithoutOldKey
                });
            }
        }
        else {
            console.error('something went wrong... not supposed to be here');
        }
    }

    const getCheckboxId = (id) => `${id}-check`;

    const Checkbox = (name, id) => {
        return (
            <div className="form-check" key={getCheckboxId(id)}>
                <input className="form-check-input" type="checkbox" id={getCheckboxId(id)} onChange={checkboxChanged}/>
                <label className="form-check-label">
                    {name}
                </label>
            </div>
        )
    };
    
    const assets = (managerName, teamId) => {
        const allPicks = underwhelmingGentsUtil.getAllPicks(outgoingPicks, managerName);

        return (
            <>
                <h4>{managerName} assets</h4>
                <form className='mb-5'>
                    <div className="mb-3 mt-3">
                        <button className="btn btn-info" style={{ width: '100%' }} type="button" data-bs-toggle="collapse" data-bs-target={`#players-${teamId}`}>
                            Players <i className="bi bi-caret-down-square"/>
                        </button>
                        <div className="collapse" id={`players-${teamId}`}>
                            {playerData.filter(player => {return player.manager === managerName}).map(player => (
                                Checkbox(`${player.name} (${player.contract})`, `${managerName}-${PLAYER_ASSET_TYPE}-${player.id}`)
                            ))}
                        </div>
                    </div>
                    <div>
                        <button className="btn btn-info" style={{ width: '100%' }} type="button" data-bs-toggle="collapse" data-bs-target={`#draft-picks-${teamId}`}>
                            Draft Picks <i className="bi bi-caret-down-square"/>
                        </button>
                        <div className="collapse" id={`draft-picks-${teamId}`}>
                            {Object.keys(allPicks).map(pickYear => (
                                <div key={`${managerName}-${pickYear}`}>
                                    {allPicks[pickYear].map((picksInRound, round) => {
                                        if (picksInRound.length) {
                                            return picksInRound.map(originalOwnerName => {
                                                const pickId = `${PICK_ASSET_TYPE}_${originalOwnerName}_${pickYear}_${round + 1}`;
                                                const draftOrder = draftOrdersByYear[pickYear]?.order || [];
                                                const pickIndex = draftOrder.findIndex(pick => pick === originalOwnerName) + 1 + (12 * round);
                                                const checkboxText = `${originalOwnerName} ${pickYear} ${round + 1}${getOrdinal(round + 1)} (${draftOrdersByYear[pickYear].isProjected ? '~' : ''}${pickIndex})`;
                                                return Checkbox(checkboxText, pickId);
                                            });
                                        }
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="mt-3">
                        <button className="btn btn-info" style={{ width: '100%' }} type="button" data-bs-toggle="collapse" data-bs-target={`#faab-${teamId}`}>
                            FAAB <i className="bi bi-caret-down-square"/>
                        </button>
                        <div className="collapse" id={`faab-${teamId}`}>
                            {constants.eligbleFAABYears.map(year => (
                                <>
                                    <span>FAAB {year}</span>
                                    <div className="d-flex flex-row">
                                        <input
                                            className='form-check-input'
                                            type="checkbox"
                                            id={`${managerName}-${FAAB_ASSET_TYPE}-check-${year}`}
                                            onChange={checkboxChanged}
                                        />
                                        <input 
                                            type="number" 
                                            id={`${managerName}-${FAAB_ASSET_TYPE}-value-${year}`} 
                                            className="form-control"
                                            disabled={assetsToTrade[teamId] ? assetsToTrade[teamId].findIndex(asset => asset.includes(`${FAAB_ASSET_TYPE}_${year}`)) > -1 ? false : true : true}
                                            // bad naming but whatever
                                            onChange={checkboxChanged}
                                        />
                                    </div>
                                </>
                            ))}
                        </div>
                    </div>
                </form>
            </>
        )
    }

    return (
        <div id="tradeContainer">
            
            <h2>Trade Proposal</h2>
            <div className="d-flex flex-row justify-content-around">
                <div>
                    <h3>Team 1</h3>
                    { isAdmin ? 
                        <TeamSelectorDropdown
                            teams={teams}
                            handleTeamUpdate={handleTeam1IdUpdate}
                            initialTeamId={selectedTeam1Id}
                        />
                        : 
                        <h3 style={{alignContent: 'center', fontStyle: 'italic'}}>{userPermissions}</h3>
                    }
                </div>
                <div>
                    <h3>Team 2</h3>
                    <TeamSelectorDropdown
                        teams={teams}
                        handleTeamUpdate={handleTeam2IdUpdate}
                        initialTeamId={selectedTeam2Id}
                    />
                </div>
            </div>
            {assets(teams[selectedTeam1Id], selectedTeam1Id)}
            {assets(teams[selectedTeam2Id], selectedTeam2Id)}
            <h3>Summary</h3>
            {Object.keys(assetsToTrade).map(teamId => (
                <div key={teamId}>
                    <div>{`${teams[teamId]} is trading:`}</div>
                    <ul>
                        {assetsToTrade[teamId].map(asset => (
                            <li>{asset}</li>
                        ))}
                    </ul>
                </div>
            ))}
            <div className='d-grid gap-2'>
                <button className='btn btn-primary' onClick={proposeTrade}>Propose Trade</button>
            </div>
            <div>
                {loading && <Loader/>}
            </div>
        </div>
    )
}

export default Trade;